import React from 'react';
import { default as bemCssModules } from 'bem-css-modules';
import SimpleBar from 'simplebar-react';
import { ActiveShade } from '../ActiveShade/ActiveShade';
import { Shades } from '../Shades/Shades';
import { default as ContentStyles } from './Content.module.css';
const style = bemCssModules(ContentStyles);
export const Content = () => (React.createElement("div", { className: style() },
    React.createElement(SimpleBar, null,
        React.createElement("div", { className: style('scrollable') },
            React.createElement(ActiveShade, null),
            React.createElement(Shades, null)))));
